const toggleHubsOnNewAppearanceEditor = 'hubs_on_new_appearance_editor'
const pageHubpageManager = 'hubpage manager'
const pageHomepageManager = 'homepage manager'
const pageThemeManager = 'theme'
const pageProjectManager = 'projects'
const pageNavigationManager = 'navigation'

// Allows enquiry on whether a userRole has access to a page
// Where feature toggles work to a standard behaviour, the pages and toggles can be configured in the appPagePrivileges
// However, there are many feature toggles that don't conform to standard behaviour - requiring combinations of other
// toggles, other data and reversing boolean behaviours. These exceptions are coded in featureAllowedSpecialConditions.
// As consistent patterns arise, we can make those patterns configurable in appPagePrivileges if necessary
/**
 * @appPagePrivileges {any} - The static, application definition of role access and feature toggles per page
 * @clientFeatures {any} - The Client feature toggles. Each toggle is a property of an object
 * @state {any} - The application state
 */
const PageAccess = (appPagePrivileges: any, clientFeatures: any) => {
  // Private method to check each feature toggle in an array of toggles to see if the Client has this
  // feature toggled and if so, is it allowed
  /**
   * @featureToggles {any} - Array of feature toggles assigned for any particular page.
   * i.e. ['self_service_hubs', 'hubs_on_new_appearance_editor']
   */
  const featureAllowed = (featureToggles: any) => {
    for (
      let index = 0;
      index < featureToggles.length && clientFeatures;
      index++
    ) {
      const feature = featureToggles[index]
      const clientFeature = clientFeatures[feature]
      if (!clientFeature) {
        console.log(
          `INFO: Could not find expected feature toggle ${feature} in Client Features`,
        )
      }
      // I think this logic is correct? Features are active by default and only
      // inactive when a feature toggle exists with enabled==false
      // The assumption being that any feature toggle defined for the app should have a value in ClientFeatures
      if (clientFeature && !clientFeature.enabled) return false
    }

    return true
  }

  // Private method for extra combinations of feature toggles that cannot be configured through
  // pagePrivileges structure
  const featureAllowedSpecialConditions = (page: string) => {
    if (page === pageHubpageManager) {
      // if page is old hub page
      if (clientFeatures[toggleHubsOnNewAppearanceEditor]?.enabled) {
        return false
      }
    }

    if (page === pageHomepageManager || page === pageThemeManager) {
      return false
    }

    if (page === pageProjectManager) {
      if (clientFeatures['project_tag_manager']?.enabled) {
        return false
      }
    }

    if (page === pageNavigationManager) {
      return false
    }

    return true
  }

  const canView = (page: string, userRole: string) => {
    const pagePrivilege = appPagePrivileges.find(
      (item: any) => item.name === page,
    )

    if (!pagePrivilege) {
      // console.log(`Error: Page Privilege ${page} not found`)
      return false
    }

    const canViewPage = pagePrivilege.allowedRoles.includes(userRole)
    const isAllowed = featureAllowed(pagePrivilege.featureToggles)
    const passesSpecialRules = featureAllowedSpecialConditions(page)
    return canViewPage && isAllowed && passesSpecialRules
  }

  return { canView }
}

export default PageAccess
